import React from 'react'
import CustomTab from '../common/tab'
import './styles.scss'
import { DashboardHeader } from '@modules/admin/Admin.Header'
import Consultations from '@services/Consultations'
import { PROFESSIONAL_GROUPS, USER_GROUPS } from '@modules/admin/groups/constants'
import { createProfessionalGroupColumns, createUserGroupColumns } from '@modules/admin/groups/actions'
import { Panel } from '@modules/admin/groups/Panel.Index'
import { useTranslation } from 'react-i18next'

const GroupsIndex = () => {
  const { t } = useTranslation()
  const tabHeaders = [
    { label: t('userGroups'), key: 'userGroups' },
    { label: t('professionalGroups'), key: 'professionalGroups' },
  ]
  const userGroupsClient = Consultations.userGroups
  const teamsClient = Consultations.teams

  return (
    <div className="groups-index">
      <DashboardHeader title={t('groups')} total={null} />
      <CustomTab headers={tabHeaders}>
        <Panel
          kind={USER_GROUPS}
          className={'group-panel'}
          buttonText={t('newUserGroups')}
          columns={createUserGroupColumns(t)}
          client={userGroupsClient}
        />
        <Panel
          kind={PROFESSIONAL_GROUPS}
          className={'group-panel'}
          buttonText={t('newProfessionalGroups')}
          columns={createProfessionalGroupColumns(t)}
          client={teamsClient}
        />
      </CustomTab>
    </div>
  )
}
export default GroupsIndex
